export function isNotEmpty(a: any) {
  return a !== null && String(a).length > 0;
}

export function isStringOfWords(s: string) {
  if (typeof s === 'string') {
    if (s.length < 1) {
      return false;
    }
    return /^[A-Za-z \-\.À-ž@0-9]+$/.test(s);
  }
  return false;
}

export function isNumber(n: number) {
  if (!isNotEmpty(n)) return false;
  return /^[0-9]*$/.test(String(n));
}
export function isPhoneNumber(n: any) {
  if (!isNotEmpty(n)) return false;
  else if (String(n).length < 6) return false;
  else if (String(n).length > 16) return false;
  return /^\+?[0-9]*$/.test(String(n));
}

export function isEmail(email: any) {
  if (typeof email === 'string') {
    //email can be at most 64 characters long
    if (email.length > 64) return false;
    //has to start&end with letter or digit. needs to have an "@" and a "." inbetween
    //before and after "@"&"." has to be at least one character
    return /^[a-zA-Z0-9]+.*@.+\.[a-zA-Z]+$/.test(email);
    //at least 4 other rules were neglected. see https://help.returnpath.com/hc/en-us/articles/220560587-What-are-the-rules-for-email-address-syntax-
  }
  return false;
}

export function isValidDayMonthYear(date: any) {
  if (typeof date === 'string') {
    if (!/^[0-9]{1,2}.[0-9]{1,2}.[0-9]{4}$/.test(date)) return false;
    const month = Number(date.split('.')[1]);
    if (month > 12 || month < 1) return false;
    const day = Number(date.split('.')[0]);
    const year = Number(date.split('.')[2]);
    /* "Here January is 1 based
    Day 0 is the last day in the previous month" */
    const daysInMonth = new Date(year, month, 0).getDate();
    return day > 0 && day <= daysInMonth;
  }
  return false;
}
export function isValidMonthYear(date: any) {
  if (typeof date === 'string') {
    if (!/^[0-9]{1,2}.[0-9]{4}$/.test(date)) return false;
    const month = Number(date.split('.')[0]);
    return month < 13 && month > 0;
  }
  return false;
}
export function isValidYear(date: string) {
  if (typeof date === 'string') {
    return /^[0-9]{4}$/.test(date);
  }
  return false;
}

//TODO add address validators
